/**
 * Mock store — estado in-memory para correr el frontend SIN backend.
 *
 * Usado por el adapter de axios cuando VITE_MOCK_MODE === 'true'
 * (default para builds de GitHub Pages).
 *
 * No hay persistencia entre reloads: lo que crees se pierde al refrescar.
 * Suficiente para demos visuales.
 */

import { seedData, type MockState } from "./seed";

const state: MockState = seedData();

/** Acceso directo al estado (mutable) */
export const mockStore = state;

/** Genera un id parecido a un ObjectId de Mongo */
export function newId(): string {
    const ts = Math.floor(Date.now() / 1000).toString(16);
    const rand = Math.floor(Math.random() * 0xffffffffffff)
        .toString(16)
        .padStart(12, "0");
    return ts + rand;
}

/** Helper para retornar después de una micro-latencia (UX más realista) */
export function withDelay<T>(value: T, ms: number = 120): Promise<T> {
    return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}
